import React from 'react';
import SiteFooter from '../components/SiteFooter';
import { useTranslation } from 'react-i18next';
import { QRCodeSVG } from 'qrcode.react';
import { ChefHat } from 'lucide-react';
import logoImg from '../assets/logo-haosong.jpg';
import LanguageSwitcher from '../components/LanguageSwitcher';

const CAMPAIGN_PHONE = '85257961378';
const CAMPAIGN_MESSAGE = '我想領取雞蛋體驗優惠';
const deeplink = `https://wa.me/${CAMPAIGN_PHONE}?text=${encodeURIComponent(CAMPAIGN_MESSAGE)}`;

const EggVoucherPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FFF7ED] via-[#F2EEE6] to-[#EBE5DB] flex flex-col">
      <header className="bg-[#C2410C] text-white py-5 px-4 shadow-md">
        <div className="max-w-3xl mx-auto flex items-center gap-3">
          <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
            <ChefHat size={28} />
          </div>
          <h1 className="text-xl md:text-2xl font-bold">{t('mydash:egg.brand')}</h1>
          <div className="ml-auto">
            <LanguageSwitcher size="sm" />
          </div>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center p-4 md:p-8">
        <div className="max-w-xl w-full bg-white rounded-[2rem] shadow-2xl border-2 border-orange-100 p-8 md:p-12 text-center">
          <div className="mb-8 space-y-3">
            <p className="text-base md:text-lg font-bold text-[#C2410C] tracking-wider">{t('mydash:egg.kicker')}</p>
            <h2 className="text-5xl md:text-6xl font-bold text-stone-800 leading-tight">
              {t('mydash:egg.title1')}
              <br />
              {t('mydash:egg.title2')}
            </h2>
          </div>

          <div className="mb-8 space-y-4 text-stone-700 text-xl md:text-2xl leading-relaxed">
            <p>
              <span className="font-bold text-[#C2410C]">{t('mydash:egg.limit')}</span>
            </p>
            <p>
              {t('mydash:egg.scanCta')}
              <br />
              {t('mydash:egg.claimPrefix')} <span className="font-bold text-[#C2410C]">HK$30</span> {t('mydash:egg.claimSuffix')}
            </p>
            <p className="text-lg md:text-xl text-stone-500">
              {t('mydash:egg.validity')}
            </p>
          </div>

          <div className="flex justify-center mb-8">
            <div className="bg-white p-5 rounded-3xl border-4 border-orange-100 shadow-inner">
              <QRCodeSVG
                value={deeplink}
                size={320}
                level="M"
                includeMargin={false}
                bgColor="#ffffff"
                fgColor="#C2410C"
                imageSettings={{
                  src: logoImg,
                  height: 56,
                  width: 56,
                  excavate: true,
                }}
              />
            </div>
          </div>

          <p className="text-base md:text-lg text-stone-400">
            {t('mydash:egg.footnote')}
          </p>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
};

export default EggVoucherPage;
